import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { BsChevronDown, BsChevronUp, BsX } from 'react-icons/bs'
import { FaArrowLeft, FaClipboardList } from 'react-icons/fa'
import { LuGraduationCap } from 'react-icons/lu'
import { useNavigate } from 'react-router-dom'
import Cookies from 'js-cookie'
import toast from 'react-hot-toast'
import ApiEndpoints from './commonComponents/ApiEndpoints'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'

const fieldStyle = {
  borderRadius: '8px',
  border: '1px solid #D1D3D4',
  backgroundColor: '#ffffff',
  color: '#111827',
  fontSize: '14px',
  fontFamily: 'Inter, system-ui, sans-serif',
  minHeight: '44px',
}

export default function AddExamForCourse() {
  const navigate = useNavigate()
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const { logo } = useInstitute()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const [courses, setCourses] = useState([])
  const [openMarkingSchemeInput, setOpenMarkingSchemeInput] = useState(false)
  const [selectedExamCourses, setSelectedExamCourses] = useState([])
  const [showCourseDropdown, setShowCourseDropdown] = useState(false)
  const [newExam, setNewExam] = useState({
    course_id: '',
    exam_name: '',
    exam_location: '',
    start_date: '',
    end_date: '',
    status: '',
    marking_scheme: '',
    passing_marks: '',
    total_marks: '',
    session: '',
  })
  const [, setSession] = useState([])

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  useEffect(() => {
    ApiEndpoints.getAllCourses().then((res) => setCourses(res.data.data))
  }, [])

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const res = await ApiEndpoints.getSession()
        console.log('Session resp: ', res.data._year)
        setSession(res.data.session_year)
      } catch (error) {
        console.error(error.response?.data?.message)
      }
    }
    fetchSession()
  }, [])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewExam((prev) => ({ ...prev, [name]: value }))
  }

  const handleExamCourseToggle = (e) => {
    const selectedId = e.target.value
    const isChecked = e.target.checked
    const numericId = isNaN(Number(selectedId)) ? selectedId : Number(selectedId)
    const prevIds = Array.isArray(selectedExamCourses) ? selectedExamCourses : []
    const updated = isChecked
      ? [...prevIds, numericId]
      : prevIds.filter((id) => id.toString() !== numericId.toString())
    setSelectedExamCourses(updated)
  }

  const handleSelectAllExamCourses = (e) => {
    if (e.target.checked) {
      setSelectedExamCourses(courses.map((course) => course.id))
    } else {
      setSelectedExamCourses([])
    }
  }

  const handleRemoveExamCourse = (courseId) => {
    setSelectedExamCourses((prev) =>
      (Array.isArray(prev) ? prev : []).filter(
        (id) => id.toString() !== courseId.toString(),
      ),
    )
  }

  const getMarkingSchemeDynamic = () => {
    switch (newExam.marking_scheme) {
      case 'number':
        return 'Enter Passing Number'
      case 'grade':
        return 'Enter Passing Grade'
      case 'grade_number':
        return 'Enter Passing Marks'
      default:
        return 'Enter Marking Scheme'
    }
  }

  const goBack = () => {
    navigate('/ExamSheet')
  }

  const handleSave = async () => {
    try {
      const selectedIds = Array.isArray(selectedExamCourses)
        ? selectedExamCourses
        : []

      if (!selectedIds.length) {
        toast.error('Please select at least one course.')
        return
      }

      const institueId = Cookies.get('institute_id')
      const payload = {
        ...newExam,
        course_ids: selectedIds,
        institute_id: Number(institueId),
      }
      delete payload.course_id
      console.log('Sending data in payload: ', payload)
      const response = await ApiEndpoints.addExamMultiple(payload)
      setNewExam('Response: ', response)
      setNewExam({
        course_id: '',
        exam_name: '',
        exam_location: '',
        start_date: '',
        end_date: '',
        status: '',
        marking_scheme: '',
        passing_marks: '',
        total_marks: '',
        session: '',
      })
      setSelectedExamCourses([])
      setShowCourseDropdown(false)

      toast.success(response.data.message)
      navigate('/ExamSheet')
    } catch (error) {
      toast.error(error.response?.data?.message)
    }
  }

  const focusField = (e) => {
    e.target.style.borderColor = '#223843'
    e.target.style.boxShadow = '0 0 0 1px rgba(34, 56, 67, 0.15)'
  }
  const blurField = (e) => {
    e.target.style.borderColor = '#D1D3D4'
    e.target.style.boxShadow = 'none'
  }

  return (
    <>
      <style>
        {`
          .add-exam-page .form-label {
            font-size: 13px;
            font-weight: 600;
            color: #374151;
            font-family: Inter, system-ui, sans-serif;
            margin-bottom: 6px;
          }
          .add-exam-page .form-control,
          .add-exam-page .form-select {
            border-radius: 8px;
            border: 1px solid #D1D3D4;
            min-height: 44px;
            font-size: 14px;
            color: #111827;
            font-family: Inter, system-ui, sans-serif;
          }
          .add-exam-page .form-control:focus,
          .add-exam-page .form-select:focus {
            border-color: #223843;
            box-shadow: 0 0 0 1px rgba(34, 56, 67, 0.15);
          }
        `}
      </style>
      <div
        className="add-exam-page"
        style={{
          marginLeft,
          transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          willChange: 'margin-left',
          WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
          position: 'relative',
          zIndex: 1,
          marginTop: '0px',
          paddingLeft: '12px',
          paddingRight: '12px',
        }}
      >
        <div
          className="container-fluid p-0"
          style={{
            marginTop: window.innerWidth < 992 ? '55px' : '-12px',
            paddingLeft: '0px',
            paddingRight: '0px',
          }}
        >
          <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
            <div
              className="d-flex justify-content-between align-items-center"
              style={{
                background: '#F3F4F6',
                paddingLeft: '28px',
                paddingRight: '28px',
                paddingTop: '12px',
                paddingBottom: '12px',
                overflow: 'visible',
                borderBottom: '1px solid #D1D3D4',
                width: '100%',
              }}
            >
              <div className="d-flex align-items-center gap-3">
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    overflow: 'hidden',
                    background: '#223843',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                  }}
                >
                  {!logoError ? (
                    <img
                      src={logo}
                      alt="School Logo"
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={() => setLogoError(true)}
                    />
                  ) : (
                    <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                  )}
                </div>
                <div>
                  <h3
                    className="m-0 fw-bold page-title"
                    style={{
                      letterSpacing: '-0.02em',
                      fontSize: 'clamp(18px, 2.5vw, 22px)',
                      color: '#223843',
                      lineHeight: '1.2',
                      fontFamily: 'Inter, system-ui, sans-serif',
                      textAlign: 'left',
                    }}
                  >
                    Add exam for a course
                  </h3>
                  <p
                    className="m-0 mt-1"
                    style={{
                      fontSize: '13px',
                      color: '#6b7280',
                      fontFamily: 'Inter, system-ui, sans-serif',
                      textAlign: 'left',
                    }}
                  >
                    Create an exam and assign it to one or more courses
                  </p>
                </div>
              </div>
              {!isMobile && <ProfileDropdown logout={logout} />}
            </div>
          </div>
        </div>

        <div
          className="container-fluid p-0 mt-4"
          style={{
            minHeight: '100vh',
            paddingLeft: isCollapsed ? '32px' : '40px',
            paddingRight: '32px',
            paddingTop: '8px',
            paddingBottom: '48px',
          }}
        >
          {/* <button
            type="button"
            onClick={goBack}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '8px',
              background: '#ffffff',
              border: '1px solid #D1D3D4',
              borderRadius: '10px',
              padding: '8px 14px',
              fontSize: '13px',
              fontWeight: 600,
              color: '#223843',
              cursor: 'pointer',
              fontFamily: 'Inter, system-ui, sans-serif',
              marginBottom: '20px',
            }}
          >
            <FaArrowLeft size={13} />
            Back to exams
          </button> */}

          <div
            style={{
              background: 'transparent',
              width: '100%',
            }}
          >
            {/* <div
              style={{
                background: '#223843',
                padding: '18px 24px',
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
              }}
            >
              <div
                style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '8px',
                  background: 'rgba(255,255,255,0.12)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                <FaClipboardList size={16} color="#ffffff" />
              </div>
              <div>
                <div
                  style={{
                    fontSize: '16px',
                    fontWeight: 600,
                    color: '#ffffff',
                    fontFamily: 'Inter, system-ui, sans-serif',
                    textAlign: 'left',
                  }}
                >
                  Add exam for a course
                </div>
                <div
                  style={{
                    fontSize: '12px',
                    color: 'rgba(255,255,255,0.7)',
                    fontFamily: 'Inter, system-ui, sans-serif',
                    textAlign: 'left',
                  }}
                >
                  Fill in the exam details and choose the courses
                </div>
              </div>
            </div> */}

            <Form style={{ padding: '24px' }}>
              <Form.Group className="mb-4 text-start">
                <Form.Label>Course *</Form.Label>
                {Array.isArray(selectedExamCourses) && selectedExamCourses.length > 0 && (
                  <div
                    style={{
                      display: 'flex',
                      flexWrap: 'wrap',
                      gap: '6px',
                      marginBottom: '8px',
                    }}
                  >
                    {selectedExamCourses.map((id) => {
                      const course = courses.find(
                        (item) =>
                          item.id === id || item.id.toString() === id.toString(),
                      )
                      if (!course) return null
                      return (
                        <span
                          key={id}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            gap: '4px',
                            backgroundColor: '#F3F4F6',
                            border: '1px solid #D1D3D4',
                            borderRadius: '16px',
                            padding: '4px 6px 4px 12px',
                            fontSize: '13px',
                            color: '#111827',
                            fontFamily: 'Inter, system-ui, sans-serif',
                          }}
                        >
                          {course.name}
                          <button
                            type="button"
                            aria-label={`Remove ${course.name}`}
                            onClick={() => handleRemoveExamCourse(id)}
                            style={{
                              border: 'none',
                              background: 'transparent',
                              padding: 0,
                              lineHeight: 1,
                              cursor: 'pointer',
                              display: 'inline-flex',
                              alignItems: 'center',
                              color: '#374151',
                            }}
                          >
                            <BsX size={16} />
                          </button>
                        </span>
                      )
                    })}
                  </div>
                )}
                <button
                  type="button"
                  onClick={() => setShowCourseDropdown((prev) => !prev)}
                  style={{
                    ...fieldStyle,
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    padding: '8px 12px',
                    cursor: 'pointer',
                    textAlign: 'left',
                  }}
                >
                  <span style={{ color: selectedExamCourses?.length ? '#212529' : '#6c757d' }}>
                    {Array.isArray(selectedExamCourses) && selectedExamCourses.length > 0
                      ? `${selectedExamCourses.length} course${
                          selectedExamCourses.length > 1 ? 's' : ''
                        } selected`
                      : 'Select Course'}
                  </span>
                  {showCourseDropdown ? (
                    <BsChevronUp size={16} color="#6c757d" />
                  ) : (
                    <BsChevronDown size={16} color="#6c757d" />
                  )}
                </button>
                {showCourseDropdown && (
                  <div
                    style={{
                      border: '1px solid #D1D3D4',
                      borderTop: 'none',
                      borderRadius: '0 0 8px 8px',
                      padding: '10px 12px',
                      backgroundColor: '#fff',
                      maxHeight: '220px',
                      overflowY: 'auto',
                      textAlign: 'left',
                    }}
                  >
                    {courses.length === 0 ? (
                      <div style={{ color: '#6c757d' }}>No courses available</div>
                    ) : (
                      <>
                        <Form.Check
                          type="checkbox"
                          id="select-all-exam-courses"
                          label={`Select All (${
                            Array.isArray(selectedExamCourses)
                              ? selectedExamCourses.length
                              : 0
                          }/${courses.length})`}
                          checked={
                            courses.length > 0 &&
                            Array.isArray(selectedExamCourses) &&
                            selectedExamCourses.length === courses.length
                          }
                          onChange={handleSelectAllExamCourses}
                          className="mb-2 fw-semibold"
                        />
                        <hr className="my-2" />
                        {courses.map((course) => {
                          const selectedIds = Array.isArray(selectedExamCourses)
                            ? selectedExamCourses
                            : []
                          return (
                            <Form.Check
                              key={course.id}
                              type="checkbox"
                              id={`exam-course-${course.id}`}
                              label={course.name}
                              value={course.id}
                              checked={selectedIds.some(
                                (id) => id.toString() === course.id.toString(),
                              )}
                              onChange={handleExamCourseToggle}
                              className="mb-2"
                            />
                          )
                        })}
                      </>
                    )}
                  </div>
                )}
              </Form.Group>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3 text-start">
                    <Form.Label>Exam Name</Form.Label>
                    <Form.Control
                      type="text"
                      name="exam_name"
                      value={newExam.exam_name}
                      onChange={handleInputChange}
                      placeholder="Enter Exam Name"
                      onFocus={focusField}
                      onBlur={blurField}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3 text-start">
                    <Form.Label>Location</Form.Label>
                    <Form.Control
                      type="text"
                      name="exam_location"
                      value={newExam.exam_location}
                      onChange={handleInputChange}
                      placeholder="Enter Exam Location"
                      onFocus={focusField}
                      onBlur={blurField}
                    />
                  </Form.Group>
                </div>
              </div>

              <Form.Group className="mb-3 text-start">
                <Form.Label>Marking Scheme</Form.Label>
                <Form.Select
                  value={newExam.marking_scheme}
                  onChange={(e) => {
                    setNewExam((prev) => ({
                      ...prev,
                      marking_scheme: e.target.value,
                    }))
                    setOpenMarkingSchemeInput(true)
                  }}
                  onFocus={focusField}
                  onBlur={blurField}
                >
                  <option value="">Select</option>
                  <option value="number">Number</option>
                  {/* <option value="grade">Grade</option>
                  <option value="grade_number">Grade & Number</option> */}
                </Form.Select>
              </Form.Group>

              {openMarkingSchemeInput && (
                <Form.Group className="mb-3 text-start">
                  <Form.Label>{getMarkingSchemeDynamic()}</Form.Label>
                  <Form.Control
                    type="text"
                    name="passing_marks"
                    value={newExam.passing_marks || ''}
                    onChange={(e) =>
                      setNewExam((prev) => ({
                        ...prev,
                        passing_marks: e.target.value,
                      }))
                    }
                    placeholder={getMarkingSchemeDynamic()}
                    onFocus={focusField}
                    onBlur={blurField}
                  />
                </Form.Group>
              )}

              {newExam.passing_marks && (
                <p className="text-danger fst-italic text-start" style={{ fontSize: '13px' }}>
                  The passing marks cannot be edited later. Please fill it carefully.
                </p>
              )}

              <Form.Group className="mb-3 text-start">
                <Form.Label>Total Marks</Form.Label>
                <Form.Control
                  type="number"
                  name="total_marks"
                  value={newExam.total_marks}
                  onChange={handleInputChange}
                  placeholder="Enter Total Marks"
                  onFocus={focusField}
                  onBlur={blurField}
                />
              </Form.Group>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3 mt-1 text-start">
                    <Form.Label>Start Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="start_date"
                      value={newExam.start_date}
                      onChange={handleInputChange}
                      onFocus={focusField}
                      onBlur={blurField}
                    />
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3 mt-1 text-start">
                    <Form.Label>End Date</Form.Label>
                    <Form.Control
                      type="date"
                      name="end_date"
                      value={newExam.end_date}
                      onChange={handleInputChange}
                      onFocus={focusField}
                      onBlur={blurField}
                    />
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <Form.Group className="mb-3 text-start">
                    <Form.Label>Status</Form.Label>
                    <Form.Select
                      name="status"
                      value={newExam.status}
                      onChange={handleInputChange}
                      onFocus={focusField}
                      onBlur={blurField}
                    >
                      <option value="">Select Status</option>
                      {/* <option value="complete">complete</option> */}
                      <option value="upcoming">Upcoming</option>
                      <option value="cancel">cancel</option>
                    </Form.Select>
                  </Form.Group>
                </div>
                <div className="col-md-6">
                  <Form.Group className="mb-3 text-start">
                    <Form.Label>Session</Form.Label>
                    <Form.Select
                      name="session"
                      value={newExam.session}
                      onChange={handleInputChange}
                      onFocus={focusField}
                      onBlur={blurField}
                    >
                      <option value="">Select Session</option>
                      {/* {session.map((year, index)=>( */}
                      <option value="2026-27">2026-27</option>
                      {/* ))} */}
                    </Form.Select>
                  </Form.Group>
                </div>
              </div>
            </Form>

            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                padding: '16px 24px',
                borderTop: '1px solid #E5E7EB',
                background: '#F9FAFB',
              }}
            >
              <Button
                variant="secondary"
                onClick={() => {
                  setShowCourseDropdown(false)
                  goBack()
                }}
                style={{
                  borderRadius: '8px',
                  minWidth: '96px',
                  fontFamily: 'Inter, system-ui, sans-serif',
                  fontWeight: 600,
                }}
              >
                Close
              </Button>
              <Button
                variant="success"
                onClick={handleSave}
                style={{
                  borderRadius: '8px',
                  minWidth: '96px',
                  fontFamily: 'Inter, system-ui, sans-serif',
                  fontWeight: 600,
                }}
              >
                Save
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
